import _extends from 'babel-runtime/helpers/extends';

import { userListAPI, depListAPI } from '@/api/common';
import PinyinMatch from 'pinyin-match';

export default {
  props: {
    radio: {
      type: Boolean,
      default: false
    },
    showPreview: {
      type: Boolean,
      default: false
    },
    // 编辑时 -- 用户默认勾选的数据
    userCheckedData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 编辑时 -- 部门默认勾选的数据
    depCheckedData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 是否关闭某个类的选择
    closeUser: {
      type: Boolean,
      default: false
    },
    closeDep: {
      type: Boolean,
      default: false
    },
    userRequest: Function,
    userParams: Object
  },
  data: function data() {
    return {
      activeTabName: 'user',
      // 筛选
      searchUserInput: '',
      searchDepInput: '',
      checkAll: false,
      isIndeterminate: false,
      // 内容展示
      popoverContentShow: false,
      // 加载动画
      userLoading: false,
      depLoading: false,
      // 所有用户
      userList: [],
      // 展示客户
      depShowList: [],
      // 面包屑数据
      breadcrumbList: [],
      // 选中的数据 -- 员工和部门一个数组用于页面展示
      checkedUserDepList: []
    };
  },

  computed: {
    userSelectCount: function userSelectCount() {
      return this.checkedUserDepList.filter(function (item) {
        return item.type == 'user';
      }).length;
    },
    depSelectCount: function depSelectCount() {
      return this.checkedUserDepList.filter(function (item) {
        return item.type == 'dep';
      }).length;
    }
  },
  watch: {
    userCheckedData: function userCheckedData() {
      this.updateCheckInfoByWatch();
    },
    depCheckedData: function depCheckedData() {
      this.updateCheckInfoByWatch();
    },
    userRequest: function userRequest() {
      this.getUserList();
    },

    // popoverVisible(val) {
    //   if (val) {
    //     this.updateCheckInfoByWatch()
    //   }

    //   this.$emit('show', val)
    // },
    userList: {
      handler: function handler() {
        var selectItems = this.userList.filter(function (item) {
          return item.isCheck;
        });
        this.refreshAllCheck(selectItems.length);
      },

      deep: true,
      immediate: true
    }
  },
  created: function created() {
    this.initInfo();
  },

  methods: {
    initInfo: function initInfo() {
      // 用户列表
      this.checkedUserDepList = this.userCheckedData.map(function (item) {
        item.type = 'user';
        return item;
      }).concat(this.depCheckedData.map(function (item) {
        item.type = 'dep';
        return item;
      }));

      if (!this.closeUser) {
        this.getUserList();
      } else if (!this.closeDep) {
        this.activeTabName = 'dep';
        this.getDepList();
      }
    },
    tabClick: function tabClick() {
      if (this.activeTabName == 'dep') {
        if (this.depShowList.length == 0) {
          this.getDepList();
        }
      }
    },
    userSearchChange: function userSearchChange(val) {
      this.userList = this.userList.map(function (item) {
        item.hidden = !PinyinMatch.match(item.realname, val);
        return item;
      });
    },
    depSearchChange: function depSearchChange(val) {
      this.depShowList = this.depShowList.map(function (item) {
        item.hidden = !PinyinMatch.match(item.name, val);
        return item;
      });
    },

    /**
     * 部门信息
     */
    getDepList: function getDepList() {
      var _this = this;

      this.depLoading = true;
      depListAPI({ type: 'tree' }).then(function (res) {
        _this.depShowList = res.data.map(function (item, index, array) {
          item.type = 'dep';
          item.isCheck = _this.getItemCheckInfo(item, 'dep');
          return item;
        });
        _this.breadcrumbList.push({ label: '全部', data: _this.depShowList });
        _this.depLoading = false;
      }).catch(function () {
        _this.depLoading = false;
      });
    },

    // 部门下一级
    enterDepChildren: function enterDepChildren(depItem) {
      var _this2 = this;

      if (depItem.children) {
        this.depShowList = [];
        this.depShowList = depItem.children.map(function (item, index, array) {
          item.type = 'dep';
          item.hidden = !PinyinMatch.match(item.name, _this2.searchDepInput);
          item.isCheck = _this2.getItemCheckInfo(item, 'dep');
          return item;
        });
        this.breadcrumbList.push({
          label: depItem.label,
          data: this.depShowList
        });
      }
    },

    // 面包屑点击事件
    breadcrumbBtn: function breadcrumbBtn(item, index) {
      var _this3 = this;

      if (index + 1 <= this.breadcrumbList.length - 1) {
        this.breadcrumbList.splice(index + 1, this.breadcrumbList.length - 1);
      }
      this.depShowList = [];
      this.depShowList = item.data.map(function (item, index, array) {
        if (item.name.indexOf(_this3.searchDepInput) != -1) {
          item.hidden = false;
        } else {
          item.hidden = true;
        }
        item.isCheck = _this3.getItemCheckInfo(item, 'dep');
        return item;
      });
    },

    // 部门勾选
    depCheckboxChange: function depCheckboxChange(item, aindex) {
      if (this.radio) {
        this.checkedUserDepList = item.isCheck ? [_extends({}, item)] : [];
        this.handleAllCheckStatus();
        this.valueChange();
      }
      // this.$set(this.depShowList, aindex, item)
      if (!this.radio) {
        this.updateCheckedUserDepListByCheck(item, 'dep');
      }
    },

    /**
     * 员工操作
     */
    getUserList: function getUserList() {
      var _this4 = this;

      this.userLoading = true;
      var request = userListAPI;
      var params = {};
      if (this.userRequest) {
        request = this.userRequest;
        params = this.userParams || {};
      } else {
        params = { pageType: 0 };
      }
      request(params).then(function (res) {
        var userList = res.data.list || res.data;
        _this4.userList = userList.map(function (item) {
          item.type = 'user';
          item.isCheck = _this4.getItemCheckInfo(item, 'user');
          return item;
        });
        _this4.userLoading = false;
      }).catch(function () {
        _this4.userLoading = false;
      });
    },

    // 员工勾选
    userCheckboxChange: function userCheckboxChange(item, aindex) {
      if (this.radio) {
        this.checkedUserDepList = item.isCheck ? [_extends({}, item)] : [];
        this.handleAllCheckStatus();
        this.valueChange();
      }
      // this.$set(this.userList, aindex, item)
      if (!this.radio) {
        this.updateCheckedUserDepListByCheck(item, 'user');
      }
    },


    /**
     * 刷新总check
     */
    refreshAllCheck: function refreshAllCheck(checkedCount) {
      this.checkAll = checkedCount === this.userList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.userList.length;
    },


    /**
     * 全部勾选
     */
    handleCheckAllChange: function handleCheckAllChange(val) {
      var depList = this.checkedUserDepList.filter(function (item) {
        return item.type == 'dep';
      });

      this.userList = this.userList.map(function (item) {
        item.isCheck = val;
        return item;
      });

      this.checkedUserDepList = val ? depList.concat(this.userList) : depList;
    },


    // check 操作后的 存储数据刷新
    updateCheckedUserDepListByCheck: function updateCheckedUserDepListByCheck(item, type) {
      var removeIndex = -1;
      for (var index = 0; index < this.checkedUserDepList.length; index++) {
        var element = this.checkedUserDepList[index];
        if (element.type == 'user' && item.id == element.id && type == 'user') {
          removeIndex = index;
        } else if (element.type == 'dep' && item.id == element.id && type == 'dep') {
          removeIndex = index;
        }
      }
      if (removeIndex == -1) {
        this.checkedUserDepList.push(item);
      } else if (removeIndex != -1) {
        this.checkedUserDepList.splice(removeIndex, 1);
      }
    },

    // 获取事项标记信息
    getItemCheckInfo: function getItemCheckInfo(item, type) {
      if (this.checkedUserDepList.length == 0) {
        return false;
      }
      var hasItem = false;
      for (var index = 0; index < this.checkedUserDepList.length; index++) {
        var element = this.checkedUserDepList[index];
        if (element.type == 'user' && item.id == element.id && type == 'user') {
          hasItem = true;
          break;
        } else if (element.type == 'dep' && item.id == element.id && type == 'dep') {
          hasItem = true;
          break;
        }
      }
      return hasItem;
    },

    /**
     * 删除 清空 等操作
     */
    // 删除一个选择员工或部门
    selectDelete: function selectDelete(selectItem, index) {
      var _this5 = this;

      this.checkedUserDepList.splice(index, 1);
      if (selectItem.type == 'dep') {
        this.depShowList = this.depShowList.map(function (item, index, array) {
          item.isCheck = _this5.getItemCheckInfo(item, 'dep');
          return item;
        });
      } else {
        this.userList = this.userList.map(function (item, index, array) {
          item.isCheck = _this5.getItemCheckInfo(item, 'user');
          return item;
        });
      }
    },

    // 回调数据
    valueChange: function valueChange() {
      this.$emit('select', this.checkedUserDepList.filter(function (item) {
        return item.type == 'user';
      }), this.checkedUserDepList.filter(function (item) {
        return item.type == 'dep';
      }));
    },

    // 清空按钮
    clearAll: function clearAll() {
      this.checkedUserDepList = [];
      this.userList = this.userList.map(function (item) {
        item.isCheck = false;
        return item;
      });

      this.depShowList = this.depShowList.map(function (item) {
        item.isCheck = false;
        return item;
      });
    },

    // 监听父类改变更新check
    updateCheckInfoByWatch: function updateCheckInfoByWatch() {
      this.checkedUserDepList = this.userCheckedData.map(function (item) {
        item.type = 'user';
        return item;
      }).concat(this.depCheckedData.map(function (item) {
        item.type = 'dep';
        return item;
      }));

      this.handleAllCheckStatus();
    },


    /**
     * 修改全部数据的状态啊
     */
    handleAllCheckStatus: function handleAllCheckStatus() {
      var _this6 = this;

      if (this.depShowList.length) {
        this.depShowList.forEach(function (item) {
          item.isCheck = _this6.getItemCheckInfo(item, 'dep');
        });
      }
      if (this.userList.length) {
        this.userList.forEach(function (item) {
          item.isCheck = _this6.getItemCheckInfo(item, 'user');
        });
      }
    }
  }
};